import { Api } from "./Api";
import { ArrayUtil } from "./ArrayUtil";
import { ExternalLink } from "./ExternalLink";

export class HelpLink extends ExternalLink {
    // Note that the 'url' member of a HelpLinks can be a url or a video item id
    // If a video item id, finalized url is resolved by calling helplink/create-url below

    protected override async resolveURL(): Promise<void> {
        if (this.urlIsValid() === true) {
            return;
        }
        // HelpLink is assumed to be a video ID, ask the server for a current URL to access that video
        const response = await Api.post("helplink/create-url", { id: this.url });
        const data = ArrayUtil.getFirstElement(response?.data);
        this.url = data?.url;
    }
}
